import styled from "styled-components";

export const Layout = styled.div`
  padding: 16px;
  font-size: 20px;
  align-items: center;
  color: #010101;

  input {
    width: 100%;
    box-sizing: border-box;
    margin: 0;
  }
`;

export const Container = styled.div`
  margin: 0 auto;
  padding: 0 16px;
`;
